export default __webpack_public_path__ + "static/media/330_private01-jp-web.9c246f45.png";